import styled from 'styled-components';

export const SizeTitle = styled.h2`
  font-size: 13px;
  font-weight:normal;
  text-transform:uppercase;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
`

export const SizeList = styled.ul`
  list-style-type: none;
  @media (max-width: 768px) {

  }
`;

export const SizeListItem = styled.li`
    border-bottom: 1px solid gainsboro;
    display:flex;
    padding: ${props => props.hideInfo ? '5px 0px' : '0'};

    @media (max-width: 768px) {
      &:first-child {
        border-top: 1px solid gainsboro;
      }
    }
`;


export const InfoButton = styled.div`
  display: flex;
  background: #d4d3d8;
  padding: 5px;
  height: 45px;
  align-items: center;
  color: #fff;
  font-family: sans-serif;
  outline: 0;
  margin-left: 10px;

  &:hover {
    cursor: pointer;
    background: gray;
  } 
`

export const LineWrapper = styled.div`
  display: flex;
  width:100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  input {
    width: 100px !important;
    height: 35px !important;
    border-radius: 4px !important;
  }

  @media (max-width: 768px) {
    input {
      padding: 0 45px 0 15px !important;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin: 20px 0px;
  
  @media (max-width: 768px) {
    margin: 20px 0 0;
    button {
      &:not(:last-child){
        margin: 0 0 12px
      }
    };
  };
`

export const ListWrapper = styled.div`
  padding: 10px 20px;
  //margin: 15px 5px 25px 5px;
  text-align:center;

  @media (max-width: 768px) {
    padding: 20px 25px;
    margin: 0;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FormGroup = styled.fieldset`
${props => props.loginState ? "margin: 40px 0 0;" : "margin: 0;"}
@media (max-width: 768px) {
    ${props => props.loginState ? "margin: 20px 0 0;" : "margin: 0;"}
  }
`;

export const ErrorWrapper = styled.p`
  color: brown;
  font-size: smaller;
  text-transform: lowercase;
  text-align: center;
  margin: 0px 5px;
`

export const HelpTitle = styled.p`
  text-align: left;
  border-bottom: 1px solid #E3E3E3;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 15px 0;
    margin: 15px 0;
    border-bottom: 1px solid #E3E3E3;
  }
`

export const ExpertModeToggle = styled.p`
  margin-top:10px;
  text-align: left;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }

  &:after {
    content: '';
    margin-left: 5px;
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: ${props => props.expretMode ? 'rotate(-135deg)' : 'rotate(45deg)'};
  }

  @media (max-width: 768px) {
    font-size: 14px;
    color: #D2D2D2;
    // padding-left: 25px;
    margin: 20px 0 0;

    &:after {
      border-color: #D2D2D2;
    }
  }
`

export const ButtonIcon = styled.img`
  height: 24px;
  width: 24px;
  vertical-align: middle;
  margin: 0 20px 0 10px;

  @media (max-width: 768px) {
    margin: 0 4px 0 0;
  }
`

export const ButtonLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
`